export const dateUtil = {
  methods:{
    dateFormatYMD(time,s) {                                       //改变时间格式函数
      var hour = new Date(time).getTimezoneOffset()*60000
      var date = new Date(time+28800000+hour),
      year = date.getFullYear(),
      m = parseInt(date.getMonth()),
      mounth = m + 1 < 10 ? "0" + (m + 1) : m + 1,
      day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return year + s + mounth + s + day;
    },
    dateFormatMD(time,s) {                                       //改变时间格式函数
      var date = new Date(time),
      m = parseInt(date.getMonth()),
      mounth = m + 1 < 10 ? '0' + (m + 1) : m + 1,
      day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      return  mounth + s + day;
    },
    dateFormatHM(time,s) {                                       //改变时间格式函数
      var hour = new Date(time).getTimezoneOffset()*60000
      var date = new Date(time+28800000+hour),
      h = date.getHours(),
      hours = h < 10 ? "0" + h : h,
      m = date.getMinutes(),
      minutes = m < 10 ? "0" + m : m;
      if(!s){
        s=":"
      }
      return hours + s + minutes;
    },
    dateFormatYMDHM(time,s){
      return this.dateFormatYMD(time,s)+" "+this.dateFormatHM(time)
    },
    dateFormatYMDHMS(time,type) {
      var hour = new Date().getTimezoneOffset()*60000
      var date = new Date(time+(28800000+hour)),
      year = date.getFullYear(),
      m = parseInt(date.getMonth()),
      mounth = m + 1 < 10 ? "0" + (m + 1) : m + 1,
      day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate(),
      h = date.getHours(),
      hours = h < 10 ? "0" + h : h,
      m = date.getMinutes(),
      minutes = m < 10 ? "0" + m : m,
      s=date.getSeconds(),
      second=s<10?"0"+s:s;
      return year + type + mounth + type + day+" "+hours+":"+minutes+":"+second;
    },
    getWeekDate(time) {
      var hour = new Date().getTimezoneOffset()*60000
      var date = new Date(time+(28800000+hour));
      var weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");              
      var day = date.getDay();   
      var week = weeks[day]; 
      return week;     
    },
    getBetweenDay(travelDate){
      if(travelDate.length>0){
        var s = new Date(travelDate[0]).getTime();
        var e = new Date(travelDate[1]).getTime();
        return (e-s)/86400000;
      }else{
        return 0;
      }
    },
    dateAddDay(date,day){
      var time = new Date(date)
      time=time.setDate(time.getDate()+day);
      return new Date(time);
    },
    getTimeNumber(number){
      var dateTime = number - new Date().getTime();
      var dayHaoMiZhi = 1000*60*60*24;
      var hourHaoMiZhi = 1000*60*60;
      var minHaoMiao = 1000*60;
      var days = Math.floor(dateTime / (dayHaoMiZhi)); //天
      var hour = Math.floor((dateTime - days*dayHaoMiZhi) / hourHaoMiZhi);//小时
      var minutes = Math.floor((dateTime-days*dayHaoMiZhi - hour*hourHaoMiZhi)/minHaoMiao);
      var second = Math.floor((dateTime-days*dayHaoMiZhi-hour*hourHaoMiZhi-minutes*minHaoMiao)/1000);
      if (days < 0) {
        return "已失效"
      } else {
        var result=''
        if(days>0) result+=days+"天";
        if(hour>0) result+=hour+"小时";
        if(minutes>0) result+=minutes+"分";
        return result+second+"秒"
      }
    },
  }
}